import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import ProcessOrder from '../components/ProcessOrder'
import TaskOrder from '../components/TaskOrder'
import SearchOrder from '../components/SearchOrder'
import ExportOrder from '../components/ExportOrder'
import ContractOrder from '../components/ContractOrder'
import FollowUpOrder from '../components/FollowUpOrder'
import JianBoExportOrder from '../components/JianBoExportOrder'

const tbcolumn = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Invoice',
    field: 'invoice_no',
    sort: 'asc',
  },
  {
    label: 'Type',
    field: 'order_type',
    sort: 'asc',
  },
  {
    label: 'Service',
    field: 'service_type',
    sort: 'asc',
  },
  {
    label: 'Price($)',
    field: 'total_price',
    sort: 'asc',
  },
  {
    label: 'Tax($)',
    field: 'total_tax',
    sort: 'asc',
  },
  //   {
  //     label: 'Outstanding($)',
  //     field: 'total_outstanding',
  //     sort: 'asc',
  //   },
  //   {
  //     label: 'Discount($)',
  //     field: 'total_discount',
  //     sort: 'asc',
  //   },
  //   {
  //     label: 'Paid($)',
  //     field: 'total_paid',
  //     sort: 'asc',
  //   },
  {
    label: 'Status',
    field: 'order_status',
    sort: 'asc',
  },
  {
    label: 'Payment',
    field: 'payment_status',
    sort: 'asc',
  },
  // {
  //   label: 'Remark',
  //   field: 'remark',
  //   sort: 'asc',
  // },
  {
    label: 'Order Date',
    field: 'order_dt',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class PosOrderStorePage extends React.Component {
  _isMounted = true
  activeTab = sessionStorage.getItem('activeTab')
  comp = StorageService.getSession('selected_org')
  access = StorageService.getSession('user_access')
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
      store_id: this.props.match.params.id,
      storeRole: this.access.store.find(x => x.store_id == this.props.match.params.id).role,
      store_name: '',
      orderList: [],
      filterList: [],
      activeTab: this.activeTab ? this.activeTab : '1',
      tabList: [{ name: 'Follow Up' }, { name: 'Process' }, { name: 'Fulfilment' }, { name: 'Orders' }, { name: 'Contract' }],
      statusList: [],
      taskList: [{ name: 'In Progress' }, { name: 'Schedule' }],
      start_dt: moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      end_dt: moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      order_id_str: '',
      date: moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
    }
  }

  componentDidMount() {
    this.getOrder()
    this.getStoreDetail()
    if (this.comp.CompanyID === 'XhUFtI89G6HdfBALkPaW') {
      this.setState({
        tabList: [{ name: 'Follow Up' }, { name: 'Process' }, { name: 'Fulfilment' }, { name: 'Orders' }, { name: 'Contract' }, { name: 'SZ&W Export' }],
      })
    }

    if (this.comp.CompanyID === 'DQorvFepH2VanG9pJJgT') {
      this.setState({
        tabList: [{ name: 'Follow Up' }, { name: 'Process' }, { name: 'Fulfilment' }, { name: 'Orders' }, { name: 'Contract' }, { name: 'JianBo Export' }],
      })
    }

    if (this.comp.CompanyID === 'IsKbNNvTITlL46EQuyJ7') {
      this.setState({
        tabList: [{ name: 'Follow Up' }, { name: 'Process' }, { name: 'Fulfilment' }, { name: 'Orders' }, { name: 'Contract' }, { name: 'JianBo Export' }],
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
      this.filterOrder(this.state.orderList, tab)
    }
    sessionStorage.setItem('activeTab', tab)
  }

  getOrder() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      limit: 100,
    }

    axios
      .post(url + ':3003/v1/order', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.order_dt) {
              i.order_dt = moment(i.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
            }
            if (i.total_tax) {
              i.total_tax = parseFloat(i.total_tax).toFixed(2)
            }
            i.Action = (
              <div className="ps-action-button">
                <Button className="theme-button theme-button-secondary" onClick={() => this.order(i.order_id)}>
                  View
                </Button>
              </div>
            )
          }
          this.filterOrder(result.data)
          this.setState({
            orderList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getStoreDetail() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
    }

    axios
      .post(url + ':3001/v1/store/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            store_name: result.data.name,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  async filterOrder(data, tab = null) {
    let array
    let activeTab = tab ? tab : this.state.activeTab
    if (activeTab == 1) {
      array = data.filter(x => x.order_status === 'Order' || x.order_status === 'Preparation' || x.order_status === 'Attention' || x.order_status === 'Quotation' || x.payment_status === 'Pending Payment')
    } else if (activeTab == 2) {
      array = data.filter(x => (x.order_status === 'In Progress' || x.order_status === 'Scheduled') && x.payment_status === 'Paid' && x.order_status != 'Quotation')
    } else if (activeTab == 3) {
      array = await this.dailyOrder()
    } else {
      array = []
    }
    this.setState({
      filterList: array,
    })
  }

  dailyOrder = async () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      date: this.state.date,
    }

    const response = await axios.post(url + ':3003/v1/order/daily', data)
    const result = response.data
    if (result.error == true && result.message != 'Success') {
      alert(result.message)
      return
    }
    if (this._isMounted) {
      for (let i of result.data) {
        if (i.order_dt) {
          i.order_dt = moment(i.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
        }
        if (i.total_tax) {
          i.total_tax = parseFloat(i.total_tax).toFixed(2)
        }
        i.Action = (
          <div className="ps-action-button">
            <Button className="theme-button theme-button-secondary" onClick={() => this.order(i.order_id)}>
              View
            </Button>
          </div>
        )
      }
      this.setState({
        filterList: result.data,
      })
      return result.data
    }
  }

  searchOrder = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      start_dt: this.state.start_dt,
      end_dt: this.state.end_dt,
      order_id_str: this.state.order_id_str,
    }

    axios
      .post(url + ':3003/v1/order/search', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.order_dt) {
              i.order_dt = moment(i.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
            }
            if (i.total_tax) {
              i.total_tax = parseFloat(i.total_tax).toFixed(2)
            }
            i.Action = (
              <div className="ps-action-button">
                <Button className="theme-button theme-button-secondary" onClick={() => this.store(i.order_id)}>
                  View
                </Button>
              </div>
            )
          }
          this.setState({
            filterList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  order = id => {
    this.props.history.push({
      pathname: '/posorder/store/' + this.state.store_id + '/' + id,
    })
  }

  render() {
    //console.log(this.state.storeRole);
    const { activeTab } = this.state
    const data = {
      columns: tbcolumn,
      rows: this.state.filterList,
    }
    return (
      <Page
        className="PosOrderStorePage sidebar-open"
        title={this.state.store_name + "'s Order"}
        breadcrumbs={[
          { name: 'Store', active: false, path: '/posorder' },
          { name: 'Order', active: true, path: '/posorder' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card>
              <CardBody>
                <Nav tabs className="ps-tab">
                  {this.state.tabList.map((item, index) => {
                    return (
                      <NavItem key={item.name}>
                        <NavLink
                          className={classnames({
                            active: activeTab === (index + 1).toString(),
                          })}
                          onClick={() => {
                            this.toggleTab((index + 1).toString())
                          }}>
                          {item.name}
                        </NavLink>
                      </NavItem>
                    )
                  })}
                </Nav>

                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="py-3">
                    <FollowUpOrder state={this.state} tbcolumn={tbcolumn} order={this.order} />
                  </TabPane>
                  <TabPane tabId="2" className="py-3">
                    <ProcessOrder state={this.state} tbcolumn={tbcolumn} order={this.order} />
                  </TabPane>
                  <TabPane tabId="3" className="py-3">
                    <TaskOrder state={this.state} tbcolumn={tbcolumn} order={this.order} />
                  </TabPane>
                  <TabPane tabId="4" className="py-3">
                    <SearchOrder state={this.state} tbcolumn={tbcolumn} order={this.order} {...this.props} />
                  </TabPane>
                  <TabPane tabId="5" className="py-3">
                    <ContractOrder state={this.state} tbcolumn={tbcolumn} order={this.order} {...this.props} />
                  </TabPane>
                  {this.comp.CompanyID === 'XhUFtI89G6HdfBALkPaW' && (
                    <TabPane tabId="6" className="py-3">
                      <ExportOrder state={this.state} tbcolumn={tbcolumn} order={this.order} {...this.props} />
                    </TabPane>
                  )}
                  {(this.comp.CompanyID === 'DQorvFepH2VanG9pJJgT' || this.comp.CompanyID === 'IsKbNNvTITlL46EQuyJ7') && (
                    <TabPane tabId="6" className="py-3">
                      <JianBoExportOrder state={this.state} tbcolumn={tbcolumn} order={this.order} {...this.props} />
                    </TabPane>
                  )}
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    )
  }
}

export default PosOrderStorePage
